<button
  mat-icon-button
  type="button"
  aria-label="Fermer le formulaire"
  class="btn-clean feedback__close-btn"
  (click)="clickCross()"
>
  <mat-icon svgIcon="cross"></mat-icon>
</button>

<ng-container *ngIf="(loading$ | async) === false; else confimationMessage">
  <header role="banner" class="feedback__header">
    <h3 class="feedback__header__title">Vous avez trouvé votre solution sur la plateforme&nbsp;?</h3>
    <p class="feedback__header__subtitle">
      Partagez votre expérience en quelques lignes afin de témoigner lors du prochain événement 1jeune1solution&nbsp;!
    </p>
  </header>

  <form *ngIf="formGroup" [formGroup]="formGroup" (submit)="onSubmit()" class="feedback__form">
    <mat-form-field class="feedback__form__field feedback__form__content">
      <mat-label>Mon expérience...</mat-label>
      <textarea
        matInput
        formControlName="experience"
        cdkTextareaAutosize
        cdkAutosizeMinRows="4"
        cdkAutosizeMaxRows="6"
      ></textarea>
      <mat-error *ngIf="experience.errors as errors">
        <ng-container *ngIf="errors.required">Ce champ est requis</ng-container>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="feedback__form__field">
      <mat-label>Adresse e-mail</mat-label>
      <input type="text" matInput formControlName="email" />
      <mat-error *ngIf="email.errors as errors">
        <ng-container *ngIf="errors.required">L&apos;adresse e-mail est requise</ng-container>
        <ng-container *ngIf="errors.email">L&apos;adresse e-mail est invalide</ng-container>
      </mat-error>
    </mat-form-field>

    <button type="submit" class="btn">Je partage mon expérience</button>
  </form>
</ng-container>

<ng-template #confimationMessage>
  <div class="loader-container">
    <app-checkmark-loader class="loader" [loading]="loadingLoader$ | async"></app-checkmark-loader>

    <h4 role="heading" class="loader__title" *ngIf="(loadingLoader$ | async) === true">Envoi en cours...</h4>

    <ng-container *ngIf="(loadingLoader$ | async) === false">
      <h4 role="heading" class="loader__title">Votre message a bien été enregistré&nbsp;!</h4>

      <p class="loader__subtitle">Nous vous recontacterons en fonction du calendrier événementiel</p>

      <button type="button" class="btn" (click)="closeDialog('Button')">Fermer</button>
    </ng-container>
  </div>
</ng-template>
